import { UTILS } from "../resources"
import Vue from 'vue'

export default {
//LOTE DESTINO PRE ALOJAMENTO
  ['mtChangeListaLoteDestinoPreAlojamento'](state,payload) {
    state.listaLotesDestinoPreAlojamento = payload.map((lote, index) => _.extend(lote, {
      id: index,
      qtVazioSanitario: UTILS.formataVazioSanitario(lote['dtInicioVazio'])
    }))
  },
  ['mtChangeQtTotalDiasVazio'](state,payload) {
    state.qtTotalDiasVazio = payload
  },
  ['mtSelecionarLoteDestinoPreAlojamento'](state, payload) {
    state.listaLotesDestinoPreAlojamento[payload.id].blPreAlojado = payload.sel
  },
  ['mtAlterarGeneroLoteDestinoPreAlojamento'](state, payload) {
    state.listaLotesDestinoPreAlojamento[payload.id].sgSexoSugerido = payload.sgSexo
  },
  ['mtAdicionarLoteDestinoPreAlojamento'](state, payload) {
    state.listaLotesDestinoPreAlojamento.unshift(payload)
  },
  ['mtRemoverLoteDestinoPreAlojamento'](state, id) {
    state.listaLotesDestinoPreAlojamento.splice(id,1)
  },
  ['mtIndexarListaLoteDestinoPreAlojamento'](state, payload) {
    state.listaLotesDestinoPreAlojamento.forEach((lote, index) => _.extend(lote, {id: index}))
  },
  ['mtAlterarObservacaoLoteDestinoPreAlojamento'](state, payload) {
    Vue.set(state.listaLotesDestinoPreAlojamento[payload.id], 'dsObservacao', payload.dsObservacao)
  },
  ['mtAlterarLoadingLoteDestinoPreAlojamento'](state, payload) {
    state.loadingLoteDestinoPreAlojamento = payload
  },


//LOTE DESTINO ALOJAMENTO
  ['mtChangeListaLoteDestinoAlojamento'](state, listaCrecheLoteDestino) {
    let objetoCrecheLoteDestino = {}

    listaCrecheLoteDestino.forEach(creche => {
      objetoCrecheLoteDestino[creche['cdEstabelecimentoCreche']] = creche.lotesDestino.map((lote, index) => {
        return _.extend(lote, {
          id: index,
          qtVazioSanitario: UTILS.formataVazioSanitario(lote['dtInicioVazio'])
        })
      })
    })

    state.listaLotesDestinoAlojamento = objetoCrecheLoteDestino
  },
  ['mtChangeLoteDestinoAlojamento'](state, {cdEstabelecimentoCreche, lote}) {
    state.listaLotesDestinoAlojamento[cdEstabelecimentoCreche].splice(lote.id, 1, _.extend(lote, {
      id: lote.id,
      qtVazioSanitario: UTILS.formataVazioSanitario(lote['dtInicioVazio'])
    }))
  },
  ['mtAtualizarCapacidadeUepLoteDestino'](state, loteDestino){
    state.listaLotesAlocados.forEach(lote => {
      if(lote.cdUnidadeExploracao === loteDestino.cdUnidadeExploracao) lote.qtCapacidadeUep = loteDestino.qtCapacidadeUep
    })
  },
  ['mtAlterarLoadingLoteDestinoAlojamento'](state, payload) {
    state.loadingLoteDestinoAlojamento = payload
  },

//LOTE ALOCADO
  ['mtChangeListaLoteAlocado'](state, payload) {
    state.listaLotesAlocados = payload
  },
  ['mtChangeLoteAlocado'](state, loteAlocado) {
    const idx = state.listaLotesAlocados.findIndex(lote => lote.idPlanejamentoAlojamentoAlocado === loteAlocado.idPlanejamentoAlojamentoAlocado)
    if (idx > -1) {
      state.listaLotesAlocados[idx] = loteAlocado
    }
    // TODO há necessidade de reportar erro ?
    // else commit("setSnack", {type: "error", msg: 'Lote alterado não encontrado na store'}, { root: true })
  },
  ['mtRemoveLoteAlocado'](state, idAlocado) {
    const idx = state.listaLotesAlocados.findIndex(lote => lote.idPlanejamentoAlojamentoAlocado === idAlocado)
    if (idx > -1) state.listaLotesAlocados.splice(idx,1)
  },
  ['mtAtualizarSaldoLotesAlocados'](state, loteAlocado){
    state.listaLotesAlocados.forEach(lote => {
      if(lote.cdPlanejamentoAlojamentoLoteDestino === loteAlocado.cdPlanejamentoAlojamentoLoteDestino)
        lote.qtTotalAlocado = loteAlocado.qtTotalAlocado
    })
  },

// ACTIONS LOTE ALOCADO
  ['mtPreparaRemoverLoteAlocado'](state, loteAlocado) {
    const idx = state.listaLotesAlocados.findIndex(lote => lote.idPlanejamentoAlojamentoAlocado === loteAlocado.idPlanejamentoAlojamentoAlocado)
      Vue.set(state.listaLotesAlocados[idx], 'blConfirmarDelecao', true)
  },
  ['mtUndoDeleteLoteAlocado'](state, loteAlocado) {
    const idx = state.listaLotesAlocados.findIndex(lote => lote.idPlanejamentoAlojamentoAlocado === loteAlocado.idPlanejamentoAlojamentoAlocado)
    if (idx > -1) {
      Vue.set(state.listaLotesAlocados[idx], 'blConfirmarDelecao', null)
    }
    // TODO há necessidade de reportar erro ?
    // else commit("setSnack", {type: "error", msg: 'Lote alterado não encontrado na store'}, { root: true })
  },
  ['mtPreparaCopiarRecortarLoteAlocado'](state, { loteAlocado, tipoAcao }) {
    const idx = state.listaLotesAlocados.findIndex(lote => lote.idPlanejamentoAlojamentoAlocado === loteAlocado.idPlanejamentoAlojamentoAlocado)
    if (idx > -1) {
      Vue.set(state.listaLotesAlocados[idx], 'sgAcaoLoteAlocado', tipoAcao)
      state.cacheLoteAlocado = loteAlocado
    }
  },
  ['mtCancelaCopiarRecortarLoteAlocado'](state) {
    const idx = state.listaLotesAlocados.findIndex(lote => {
          return lote.idPlanejamentoAlojamentoAlocado === state.cacheLoteAlocado.idPlanejamentoAlojamentoAlocado
        })
    if (idx > -1) {
        Vue.set(state.listaLotesAlocados[idx], 'sgAcaoLoteAlocado', null)
    }

    state.cacheLoteAlocado = null
  },
}
